module.exports = __webpack_public_path__ + "img/02-04_Balancing my personal.45d65ddf.svg";